import styled from 'styled-components';

export const EventsTabledDiv = styled.div`
  height: 100%;
`;
